module.exports = __webpack_public_path__ + "img/50_16.00f7addd.png";